import React from 'react';
import ColumnMenu from 'main/components/show/grid/columnHeaderCell/utilityColumnMenu.jsx';

/**
 * Utility column header cell
 *
 */
export default React.createClass({
  displayName: 'GridUtilityColumnHeaderCell',

  propTypes: {
    user: React.PropTypes.object,
    title: React.PropTypes.string.isRequired,
    id: React.PropTypes.string.isRequired,
  },

  render() {
    return (
      <div className="grid-utility-column-title">
        <div>
          {this.props.title}
          <ColumnMenu
            id={this.props.id}
            additionalItems={this.props.additionalItems}
            user={this.props.user}
          />
        </div>
      </div>
    );
  },
});
